import { Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AppService } from '../../../../../services';
import { ConfigurationAreaService } from '../../../configuration-area.service';
import { ConfigurationEmailJobsService } from '../../configuration-email-jobs.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'configuration-email-job-triggers-view-part',
	standalone: true,
	imports: [GridContentWidget],
	templateUrl: './email-job-triggers-view.part.html',
})

export class ConfigurationEmailJobTriggersViewPart {

	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly pageService = inject(ConfigurationEmailJobsService);
	private readonly areaService = inject(ConfigurationAreaService);
	public setup = getSetup(this.util, this.app);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public emailJobTriggers = computed(() => (this.areaService.configurationData()?.emailJobTriggers ?? []).map(j => ({ ...j, updatedUTC: Date.now() })));

}